import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

/**
 * A component which will render overlaid on top of it's parent element. This component will intercept and block any click through events to the parent element.
 */
@Component({
  selector: 'd-click-block-overlay',
  standalone: true,
  styleUrl: './d-click-block-overlay.component.scss',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeightonClickBlockOverlayComponent {
  @HostBinding('attr.aria-hidden') public get ariaHidden(): string {
    return 'true';
  }
}
